/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import loggerManagement from '../img/logger_management.png';
import reports from '../img/reports.png';
import uploads from '../img/uploads.png';
import users from '../img/users.png';
import auditTrail from '../img/audit_trial.png';
import companySettings from '../img/audit_trial.png';
import deviation from '../img/deviation.png';
import profiles from '../img/profiles.png';
import trials from '../img/trials.png';
import ItemLink from './ItemLink';

let styles;

const renderContent = () => (
  <div className={ css( styles.content ) }>
    {
      <ItemLink
        label="Audit Trail"
        imgSrc={ auditTrail }
        imgStyle={ styles.itemLinkImg }
        style={ styles.auditTrail }
        url="./documents/004/Clinical Module 4.14.0 User guide - Audit trail COM_DEV_012 Ver B.pdf"
      />
    }
    {
      <ItemLink
        label="Company Settings"
        leftSrc={ companySettings }
        leftStyle={ styles.leftStyleCompanySettings }
        imgSrc={ companySettings }
        imgStyle={ styles.rightStyleCompanySettings }
        style={ styles.companySettings }
        url="./documents/004/TSS_4.9.0_Userguide_Company_Settings_COM_DEV_013_verC.pdf"
      />
    }
    {
      <ItemLink
        label="Deviation"
        imgSrc={ deviation }
        imgStyle={ styles.itemLinkImg }
        style={ styles.deviation }
        url="./documents/004/TSS_4.8.0_Userguide-Deviations_COM_DEV_014-ver_G.pdf"
      />
    }

    {
      <ItemLink
        label="Logger Management"
        imgSrc={ loggerManagement }
        imgStyle={ styles.itemLinkImg }
        style={ styles.loggerManagement }
        url="./documents/004/TSS 4.11.0 Userguide - Logger management COM_DEV_015-verJ.pdf"
      />
    }
    {
      <ItemLink
        label="Profiles"
        imgSrc={ profiles }
        imgStyle={ styles.itemLinkImg }
        style={ styles.profiles }
        url="./documents/004/Clinical Module 4.14.0 User guide - Profiles COM_DEV_016 Ver. C.pdf"
      />
    }
    {
      <ItemLink
        label="Reports"
        imgSrc={ reports }
        imgStyle={ styles.itemLinkImg }
        style={ styles.reports }
        url="./documents/004/Clinical Module 4.14.0 User guide - Reports COM_DEV_017 Ver. H.pdf"
      />
    }

    {
      <ItemLink
        label="Trial Management"
        imgSrc={ trials }
        imgStyle={ styles.itemLinkImg }
        style={ styles.trials }
        url="./documents/004/TSS 4.11.0 Userguide - Trial Management COM_DEV_018-verD.pdf"
      />
    }
    {
      <ItemLink
        label="Uploads"
        imgSrc={ uploads }
        imgStyle={ styles.itemLinkImg }
        style={ styles.uploads }
        url="./documents/004/TSS 4.11.0 Userguide - Upload temperature data COM_DEV_019-verL.pdf"
      />
    }
    {
      <ItemLink
        label="Site User Registration"
        imgSrc={ users }
        imgStyle={ styles.itemLinkImg }
        style={ styles.siteUsers }
        url="./documents/004/Clinical Module 4.14.0 User guide - Site User Registration COM_DEV_020 Ver. D.pdf"
      />
    }
    {
      <ItemLink
          label="TSS BLE User Guide"
          imgSrc={ loggerManagement }
          imgStyle={ styles.itemLinkImg }
          style={ styles.tssBleUserGuide }
          url="./documents/004/Merged TSS TempMonitor BLE User Guide and Quick Installation Guide.pdf"
      />
    }

  </div>
);

const HelpContent004 = () => renderContent();

styles = StyleSheet.create( {
  container: {
    width: '100%',
  },

  content: {
    margin: '0 auto 0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'left',
  },
  itemLinkImg: {
    width: '11rem',
    height: '11rem',

    position: 'relative',
    top: '-5%',
  },
  rightStyleCompanySettings: {
    top: '5%',
    width: '6rem',
    height: '6rem',
    marginLeft: '1px',
  },
  leftStyleCompanySettings: {
    width: '8rem',
    height: '8rem',
    marginLeft: '0px',
    paddingRight: '0px',
    marginBottom: '45px',
  },
  auditTrail: {
    backgroundColor: '#0D47A1',
  },
  companySettings: {
    backgroundColor: '#1565C0',
  },
  deviation: {
    backgroundColor: '#1976D2',
  },
  loggerManagement: {
    backgroundColor: '#44546A',
  },
  tssBleUserGuide: {
    backgroundColor: '#a054cb',
  },
  profiles: {
    backgroundColor: '#586D8A',
  },
  reports: {
    backgroundColor: '#8598B1',
  },
  trials: {
    backgroundColor: '#008276',
  },
  uploads: {
    backgroundColor: '#00B09F',
  },
  siteUsers: {
    backgroundColor: '#00D0BC',
  }
} );
export default HelpContent004;



// WEBPACK FOOTER //
// ./src/components/HelpContent004.js